export default __webpack_public_path__ + "static/media/auto-clean-title.193407cf.svg";